<template>
  <div>
      <!--搜索-->
    <div class="up-search-box middle-box" :class="{ active: showSearch }" @click.self="closeSearch">
      <a href="javascript:;" class="up-close" @click="closeSearch"></a>
      <div class="middle-cont" @click.stop>
        <div class="search-box search-mobile x-show">
          <form @submit.prevent="handleSearch">
            <input
              type="text"
              class="s-inp"
              v-model="searchKeyword"
              @keydown.esc.prevent="closeSearch"
              placeholder="请输入搜索内容"
            >
            <input type="submit" class="s-btn" value="确定">
          </form>
        </div>
      </div>
    </div>
      <div class="header">
      <div class="banner">
          <img :src="bannerImage" />
      </div>
      <!-- 导航栏 -->
      <div class="nav-wrap">
        <div class="container">
          <div class="login-box">
            <a href="javascript:;" class="first" @click="$router.push({ path: '/login'})">门户登录</a>
          </div>
        </div>
        <div class="navbar" :class="{ 'navbar-fixed': isFixed, open: menuOpen }">
          <div class="navbar-header">
              <a href="/" class="header-logo" @mousemove="handleLogoGlow" @mouseleave="resetLogoGlow">
                <img src="@/assets/jadelab.png" alt="" />
              </a>
          </div>
          <div class="header-right">
              <div class="navbar-collapse" id="navbar-menu">
                <ul class="navbar-nav">
                  <li :class="{ active: $route.path === '/' || $route.path === '/search'}" @click="$router.push('/')"><a href="javascript:;">首页</a></li>
                  <li :class="{ active: $route.path === '/overview' }" @click="$router.push({ path: '/overview', query: { subtitle: 'sysgk' } })">
                    <a
                      href="javascript:;"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      >实验室概况</a
                    >
                    <ul class="dropdown-menu">
                    </ul>
                  </li>
                  <li :class="{ active: $route.path === '/alumnus' }" @click="$router.push({ path: '/alumnus', query: { subtitle: 'sztd' } })">
                    <a
                      href="javascript:;"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      >师资队伍</a
                    >
                    <ul class="dropdown-menu"></ul>
                  </li>
                  <li :class="{ active: $route.path === '/dynamic' || $route.path === '/dynamic/news'}" @click="$router.push({ path: '/dynamic', query: { subtitle: 'sysdt2' } })">
                    <a
                      href="javascript:;"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      >实验室动态</a
                    >
                    <ul class="dropdown-menu"></ul>
                  </li>
                  <li class="has-sub" :class="{ active: $route.path === '/research', expanded: expandedMenu === 'research' }" @click="onParentMenu('research', { path: '/research', query: { subtitle: 'kxyj' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >科学研究</a
                      >
                      <ul class="dropdown-menu">
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'yjfx', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >研究方向</a
                          >
                        </li>
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'kyxm', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >科研项目</a
                          >
                        </li>
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'xscg', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >学术成果</a
                          >
                        </li>
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'ryjx', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >荣誉奖项</a
                          >
                        </li>
                      </ul>
                  </li>
<!--                   <li :class="{ active: $route.path === '/platform' }" @click="$router.push({ path: '/platform', query: { subtitle: 'kypt' } })">
                    <a
                      href="javascript:;"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      >成果转化</a
                    >
                    <ul class="dropdown-menu"></ul>
                  </li> -->
                  <li class="has-sub" :class="{ active: $route.path === '/student', expanded: expandedMenu === 'student' }" @click="onParentMenu('student', { path: '/student', query: { subtitle: 'xsfc' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >学生风采</a
                      >
                      <ul class="dropdown-menu">
                        <li class="dropdown" @click.stop="$router.push({ path: '/student', query: { type: 'zd', subtitle: 'xsfc' } })">
                          <a href="javascript:;">在读</a>
                        </li>
                        <li class="dropdown" @click.stop="$router.push({ path: '/student', query: { type: 'yby', subtitle: 'xsfc' } })">
                          <a href="javascript:;">已毕业</a>
                        </li>
                      </ul>
                  </li>
                  <li :class="{ active: $route.path === '/graduate' }" @click="$router.push({ path: '/graduate', query: { subtitle: 'zsxx' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >招生信息</a
                      >
                      <ul class="dropdown-menu"></ul>
                    </li>
                </ul>
              </div>

              <div class="fr search-trigger" @click="toggleSearch"></div>

              <a class="toggle" @click="toggleMenu">
                <span></span>
              </a>
          </div>
        </div>
      </div>
      <!-- 所在位置 -->
      <div class="zjgw-bread">
        <div class="zjgw-nyln-title">
            <div class="container">
                <h1><slot name="headertitle"></slot></h1>
            </div>
        </div>
        <div class="bread-cont">
            <div class="container">
            <ul class="menu-cont">
              <slot name="menuitem">
              </slot>
            </ul>
            <div class="bread-crumbs">
                <div class="bread-item-groups">
                <div class="bread-location">您当前的位置：</div>
                <div class="bread-item">
                    <a href="javascript:;"  @click="$router.push('/')">首页</a>
                    <slot name="location"></slot>
                </div>
                </div>
            </div>
            </div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import { getBanner } from '@/api/banner.js'

export default {
  name: 'headerIndex',
  data () {
    return {
      bannerImage: '',
      isFixed: true,
      scrollThreshold: 28,
      showSearch: false,
      searchKeyword: '',
      menuOpen: false,
      expandedMenu: ''
    }
  },
  mounted () {
    this.getBannerByRoute()
  },
  watch: {
    $route () {
      this.menuOpen = false
      this.expandedMenu = ''
      this.getBannerByRoute()
    }
  },
  methods: {
    async getBannerByRoute () {
      const subtitle = this.$route.query.subtitle || 'default'
      try {
        const res = await getBanner(subtitle)
        if (res?.data?.imageUrl) {
          this.bannerImage = this.$baseUrl + res.data.imageUrl
        }
      } catch (err) {
        console.error('banner获取失败', err)
      }
    },
    handleScroll () {
      this.isFixed = true
    },
    handleLogoGlow (event) {
      const el = event.currentTarget
      const rect = el.getBoundingClientRect()
      el.style.setProperty('--logo-glow-x', `${event.clientX - rect.left}px`)
      el.style.setProperty('--logo-glow-y', `${event.clientY - rect.top}px`)
      el.style.setProperty('--logo-glow-opacity', '1')
    },
    resetLogoGlow (event) {
      const el = event.currentTarget
      el.style.setProperty('--logo-glow-opacity', '0')
    },
    toggleSearch () {
      this.showSearch = !this.showSearch
    },
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    },
    onParentMenu (key, route) {
      // 移动端：点击父级菜单只展开/收起子项，不跳转
      if (window.innerWidth <= 768) {
        this.expandedMenu = this.expandedMenu === key ? '' : key
        return
      }
      // 桌面端：保持原有的点击跳转行为
      this.$router.push(route)
    },
    closeSearch () {
      this.showSearch = false
      this.searchKeyword = ''
    },
    handleSearch () {
      const keyword = this.searchKeyword.trim()
      if (!keyword) {
        alert('请输入关键词后再进行提交')
        return
      }

      // 跳转到搜索页面，携带 keyword
      this.$router.push({
        path: '/search',
        query: {
          subtitle: 'kypt',
          keyword: keyword
        }
      })

      // 关闭搜索框
      this.showSearch = false
      this.searchKeyword = ''
    }
  }
}
</script>

<style lang="less">
.up-search-box {
    position: fixed;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transform: scale(1.2);
    opacity: 0;
    z-index: -1;
    background: rgba(0, 0, 0, 0.7);
    padding: 13.25px;
    transition: 0.3s;
    font-size: 0;
    letter-spacing: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active {
        transform: scale(1);
        opacity: 1;
        z-index: 99999;
    }
    .up-close {
        position: absolute;
        right: 13.25px;
        top: 13.25px;
        width: 21.2px;
        height: 21.2px;
        background: url('@/assets/close.png') center center / 100% 100% no-repeat;
    }
    .middle-cont {
        width: 100%;
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        letter-spacing: 0;
        .search-box {
            position: relative;
            max-width: 662.5px;
            margin-left: auto;
            margin-right: auto;
            background: rgb(234, 237, 250);
            border-bottom: 2.65px solid rgb(14, 107, 182);
            form input{
                font: inherit;
                outline: 0;
                border: 0;
                background: none;
                color: inherit;
            }
            .s-inp {
                width: 100%;
                height: 41px;
                line-height: 41px;
                font-size: 10.5px;
                padding-left: 9.9px;
                color: rgb(51, 51, 51);
            }
            .s-btn {
                height: 41px;
                line-height: 41px;
                width: 41px;
                position: absolute;
                top: 0px;
                right: 0px;
                cursor: pointer;
                z-index: 9;
                text-align: center;
                font-family: FontAwesome;
                font-size: 10.6px;
                color: rgb(14, 107, 182);
            }
        }
    }
}
.header {
  height:auto;
  min-height: 0;
  position:relative;
  background: #062845;
  .banner {
    position: relative;
    z-index: 1;
    padding-top: 70px;
    overflow: hidden;
    background: #062845;
  }
  .banner > img {
  position: static;
  display: block;
  height:auto;
  width:100%;
  object-fit: contain;
  object-position: center center;
  z-index: 1;
  border-radius: 0;
  }
  .nav-wrap{
    position:absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2147483000;
    padding:0;
    .container{
      padding:0 106px;
      .login-box{
        float:right;
        display: flex;
        align-items: center;
        gap: 14px;
        a{
          font-size: 12px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 1;
          letter-spacing: 0.02em;
          transition: color 0.25s;
          &:hover {
            color: #fff;
          }
        }
        .first{
          padding-right: 14px;
          border-right: 1px solid rgba(255,255,255,.35);
        }
      }
    }
    .navbar{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 106px;
      min-height: 64px;
      width:100%;
      background: rgba(5, 32, 58, 0.72);
      border: 1px solid rgba(255, 255, 255, 0.14);
      border-top: 0;
      border-radius: 0 0 18px 18px;
      transition: all 0.35s cubic-bezier(0.25, 0.1, 0.25, 1);
      &.navbar-fixed {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 2147483001;
        background: rgba(5, 32, 58, 0.72) !important;
        border: 1px solid rgba(255, 255, 255, 0.14);
        border-top: 0;
        border-radius: 0 0 18px 18px;
        padding: 10px 106px;
        min-height: 64px;
        .navbar-header .header-logo img {
          width: 260px;
          height: 42px;
        }
        .navbar-nav > li > a {
          color: #FFF;
          font-size: 15px;
        }
      }
      .navbar-header{
        flex-shrink: 0;
        z-index: 100;
        .header-logo{
          display: flex;
          align-items: center;
          img{
            width: 260px;
            height: 42px;
            object-fit: contain;
            display: block;
            transition: all 0.35s cubic-bezier(0.25, 0.1, 0.25, 1);
          }
        }
      }
      .header-right{
        display: flex;
        align-items: center;
        gap: 8px;
        .navbar-nav{
          display: flex;
          align-items: center;
          margin: 0;
          padding: 0;
          &>li {
            display: block;
            margin: 0 10px;
            position: relative;
            &>a{
              display: block;
              font-size: 15px;
              font-weight: 600;
              color:#FFF;
              line-height: 38px;
              padding: 0 6px;
              text-align: center;
              white-space: nowrap;
              transition: color 0.25s;
            }
            .dropdown-menu{
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-6px);
              z-index: 1000;
              opacity: 0;
              visibility: hidden;
              font-size: 14px;
              text-align: left;
              list-style: none;
              border: none;
              min-width: 90px;
              border-radius: 0 0 var(--radius-sm) var(--radius-sm);
              padding: 4px 0 0 0;
              margin: 0;
              transition: all 0.28s cubic-bezier(0.25, 0.1, 0.25, 1);
              pointer-events: none;
              &>li{
                min-width: 90px;
                height: 30px;
                background: #ffffff;
                &:first-child { border-radius: var(--radius-sm) var(--radius-sm) 0 0; }
                &:last-child { border-radius: 0 0 var(--radius-sm) var(--radius-sm); }
                &>a{
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-bottom: none;
                  color: #333333;
                  margin:0;
                  padding: 6px 12px;
                  width: 100%;
                  height: 100%;
                  line-height: 1.2;
                  font-weight: 400;
                  text-align: center;
                  font-size: 12px;
                  white-space: nowrap;
                  transition: all 0.2s;
                  &:hover{
                    color: var(--primary);
                    background: rgba(10,109,194,.06);
                  }
                }
              }
            }
            &:hover .dropdown-menu{
              opacity: 1;
              visibility: visible;
              transform: translateX(-50%) translateY(0);
              pointer-events: auto;
            }
          }
        }
        .search-trigger {
            width: 18px;
            height: 18px;
            background: url('@/assets/icon11.png') no-repeat center center;
            background-size: 100% 100%;
            margin-left: 18px;
            cursor: pointer;
            opacity: 0.8;
            transition: opacity 0.25s, filter 0.35s;
            flex-shrink: 0;
            &:hover { opacity: 1; }
        }
        .toggle {
          display: none;
        }
      }
    }
  }
  .zjgw-bread{
    position: absolute;
    bottom:0;
    width:100%;
    z-index:10;
    .zjgw-nyln-title{
        position:relative;
        &>.container{
            padding:0 106px;
            overflow: hidden;
            h1 {
                float:left;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 36px;
                padding-bottom: 17px;
                position: relative;
                font-weight: 600;
                letter-spacing: 0.02em;
                text-shadow: 0 2px 8px rgba(0,0,0,.2);
            }
        }
    }
    .bread-cont {
        background: #0E6BB6;
        min-height: 40px;
        display: flex;
        align-items: center;
        &>.container{
            width: 100%;
            padding: 0 106px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .menu-cont{
                display: flex;
                .box-a{
                    float: left;
                    margin-right: 36px;
                    position: relative;
                    &.active::after{
                        position: absolute;
                        content: "";
                        width: 0;
                        height: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: -1px;
                        border-left: 5px solid transparent;
                        border-right: 5px solid transparent;
                        border-bottom: 7px solid #FFF;
                    }
                    .a-title{
                        font-weight: 600;
                        padding: 11px 0;
                        display: block;
                        font-size: 13px;
                        color: #FFFFFF;
                        line-height: 18px;
                        letter-spacing: 0.02em;
                        transition: opacity 0.25s;
                        &:hover { opacity: 0.85; }
                    }
                }
            }
            .bread-crumbs {
                position: relative;
                .bread-item-groups {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    line-height: 30px;
                    .bread-location {
                        font-size: 11px;
                        color: rgba(255, 255, 255, 0.85);
                        line-height: 18px;
                    }
                    .bread-item {
                        display: flex;
                        align-items: center;
                        gap: 2px;
                        line-height: 18px;
                        font-size: 0;
                        &>a{
                            font-size: 11px;
                            color: rgba(255, 255, 255, 0.85);
                            line-height: 18px;
                            &:hover{
                                color: #fff;
                            }
                        }
                        &>span{
                            font-size: 11px;
                            color: rgba(255, 255, 255, 0.85);
                            line-height: 18px;
                        }
                    }
                }
            }
            }
    }
  }
}
</style>
